

// import { fetchProductById } from '../services/api';
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import './Cart.css';
// import { Link } from 'react-router-dom';
// import { API_URL } from '../services/api';

// function Cart() {
//   const [cart, setCart] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [productImages, setProductImages] = useState({});

//   const fetchCart = async () => {
//     const token = localStorage.getItem('access_token');
//     if (!token) {
//       alert("You must be logged in to view the cart.");
//       window.location.href = 'https://verdurefrontendproj.vercel.app/login';
//       return;
//     }

//     try {
//       const response = await axios.get(`${API_URL}api/cart/`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setCart(response.data);
//       const images = {};

//       for (const item of response.data.items) {
//         const variantId = item.variant_id;
//         const productId = item.product;

//         // Fetch the product details
//         const productData = await fetchProductById(productId);

//         // Get the first image from the product's images array
//         const productFirstImage = productData.images && productData.images.length > 0 
//           ? productData.images[0].image 
//           : null;

//         console.log(`Product ID: ${productId}, First Image: ${productFirstImage}`);

//         // Store product's first image
//         images[`product_${productId}`] = productFirstImage;

//         // If there's a variant, also get its first image
//         if (variantId) {
//           const variantData = productData.variants.find(v => v.id === variantId);
//           // Get the first image from the variant's images array
//           const variantFirstImage = variantData && variantData.images && variantData.images.length > 0
//             ? variantData.images[0].image
//             : null;

//           // Store variant's first image, falling back to product's first image if not available
//           images[`variant_${variantId}`] = variantFirstImage || productFirstImage;
//         }
//       }

//       console.log("Final Images Object:", images);
//       setProductImages(images);
//       setLoading(false);
//     } catch (err) {
//       console.error('Error fetching cart:', err);
//       setError('Please add to your cart');
//       setLoading(false);
//       window.location.href = 'https://verdurefrontendproj.vercel.app/login';
//     }
//   };

//   useEffect(() => {
//     fetchCart();
//   }, []);

//   if (loading) {
//     return <div>Your cart is Loading...</div>;
//   }

//   if (error) {
//     return <div>{error}</div>;
//   }

//   if (!cart || cart.items.length === 0) {
//     return <div>Your cart is empty. Please add to cart</div>;
//   }

//   const handleRemoveFromCart = async (productId, variantId = null) => {
//     try {
//       const accessToken = localStorage.getItem('access_token');
//       console.log("Removing product:", productId, "Variant:", variantId);

//       let url = `${API_URL}api/remove-from-cart/${productId}/`;

//       await axios.delete(url, {
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//         },
//         data: {
//           variant_id: variantId,
//         },
//       });

//       fetchCart();
//       alert("Item removed from cart");
//     } catch (error) {
//       console.error("Error removing item from cart:", error);
//       alert(error.response?.data?.error || "Failed to remove item.");
//     }
//   };

//   return (
//     <div className="cart">
//       <div className="pageHeader">
//         <p>Your Cart</p>
//       </div>

//       <div className="cartList">
//         {cart.items.map((item) => {
//           const productId = item.product || item.product_id;
//           const variantId = item.variant_id;

//           // Get variant image first if available, else fallback to product image
//           const imageUrl = variantId && productImages[`variant_${variantId}`]
//             ? productImages[`variant_${variantId}`]
//             : productImages[`product_${productId}`];

//           return (
//             <li key={item.id}>
//               <div className="items-cart">
//                 <div className="img-cart">
//                   {imageUrl ? (
//                     <img
//                       src={imageUrl}
//                       alt={`${item.product_name} image`}
//                       className="product-image"
//                     />
//                   ) : (
//                     <div className="no-image-placeholder">No image available</div>
//                   )}
//                 </div>
//                 <div className="prodDesc-cart">
//                   <h3>{item.product_name}</h3>
//                   {item.variant_option1 && (
//                     <p>Selection: {item.variant_option1}</p>
//                   )}
//                   {item.variant_option2 && (
//                     <p>Option 2: {item.variant_option2}</p>
//                   )}
//                   <p>Price: ${item.product_price}</p>
//                   <p>Quantity: {item.quantity}</p>
//                   <p>Total: ${item.total_price}</p>
//                 </div>
//                 <button onClick={() => handleRemoveFromCart(productId, item.variant_id)}>
//                   Remove Item
//                 </button> 
//               </div>
//             </li>
//           );
//         })}
//       </div>
//       <div className="cart-button">
//         <button className="signIn-but cart-but">
//           <Link to="/checkout">Checkout</Link>
//         </button>
//       </div>
//     </div>
//   );
// }

// export default Cart;


// import { fetchProductById } from '../services/api';
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import './Cart.css';
// import { Link } from 'react-router-dom';
// import { API_URL } from '../services/api';

// function Cart() {
//   const [cart, setCart] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [productImages, setProductImages] = useState({});
//   const [notification, setNotification] = useState({
//     show: false,
//     type: '',
//     message: ''
//   });

//   const fetchCart = async () => {
//     const token = localStorage.getItem('access_token');
//     if (!token) {
//       setNotification({
//         show: true,
//         type: 'error',
//         message: 'You must be logged in to view the cart'
//       });

//       setTimeout(() => {
//         window.location.href = '/login';
//       }, 2000);
//       return;
//     }

//     try {
//       const response = await axios.get(`${API_URL}api/cart/`, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       setCart(response.data);
//       const images = {};

//       for (const item of response.data.items) {
//         const variantId = item.variant_id;
//         const productId = item.product;

//         // Fetch the product details
//         const productData = await fetchProductById(productId);

//         // Get the first image from the product's images array
//         const productFirstImage = productData.images && productData.images.length > 0 
//           ? productData.images[0].image 
//           : null;

//         // Store product's first image
//         images[`product_${productId}`] = productFirstImage;

//         // If there's a variant, also get its first image
//         if (variantId) {
//           const variantData = productData.variants.find(v => v.id === variantId);
//           // Get the first image from the variant's images array
//           const variantFirstImage = variantData && variantData.images && variantData.images.length > 0
//             ? variantData.images[0].image
//             : null;

//           // Store variant's first image, falling back to product's first image if not available
//           images[`variant_${variantId}`] = variantFirstImage || productFirstImage;
//         }
//       }

//       setProductImages(images);
//       setLoading(false);
//     } catch (err) {
//       console.error('Error fetching cart:', err);
//       setError('Unable to load your cart. Please try again.');
//       setLoading(false);

//       setTimeout(() => {
//         window.location.href = '/login';
//       }, 2000);
//     }
//   };

//   useEffect(() => {
//     fetchCart();
//   }, []);

//   // Auto-hide notification after 3 seconds
//   useEffect(() => {
//     let timer;
//     if (notification.show) {
//       timer = setTimeout(() => {
//         setNotification(prev => ({ ...prev, show: false }));
//       }, 3000);
//     }
//     return () => {
//       if (timer) clearTimeout(timer);
//     };
//   }, [notification.show]);

//   const handleRemoveFromCart = async (productId, variantId = null) => {
//     try {
//       const accessToken = localStorage.getItem('access_token');

//       let url = `${API_URL}api/remove-from-cart/${productId}/`;

//       setLoading(true);

//       await axios.delete(url, {
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//         },
//         data: {
//           variant_id: variantId,
//         },
//       });

//       setNotification({
//         show: true,
//         type: 'success',
//         message: 'Item removed from cart'
//       });

//       fetchCart();
//     } catch (error) {
//       console.error("Error removing item from cart:", error);
//       setNotification({
//         show: true,
//         type: 'error',
//         message: error.response?.data?.error || "Failed to remove item."
//       });
//       setLoading(false);
//     }
//   };

//   const closeNotification = () => {
//     setNotification(prev => ({ ...prev, show: false }));
//   };

//   const renderEmptyCart = () => (
//     <div className="empty-cart">
//       <div className="empty-cart-icon">
//         <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//           <circle cx="9" cy="21" r="1"></circle>
//           <circle cx="20" cy="21" r="1"></circle>
//           <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
//         </svg>
//       </div>
//       <h2>Your cart is empty</h2>
//       <p>Looks like you haven't added any products to your cart yet.</p>
//       <Link to="/shop" className="shop-now-button">
//         Shop Now
//       </Link>
//     </div>
//   );

//   return (
//     <div className="cart-page">
//       {/* Loading Spinner */}
//       {loading && (
//         <div className="loading-overlay">
//           <div className="spinner"></div>
//         </div>
//       )}

//       {/* Notification Component */}
//       {notification.show && (
//         <div className={`notification-popup ${notification.type}`}>
//           <div className="notification-content">
//             <span className="notification-message">{notification.message}</span>
//             <button 
//               className="notification-close-button"
//               onClick={closeNotification}
//             >
//               ×
//             </button>
//           </div>
//         </div>
//       )}

//       <div className="cart-header">
//         <h1>Your Cart</h1>
//         {cart && cart.items.length > 0 && (
//           <span className="item-count">{cart.items.length} {cart.items.length === 1 ? 'item' : 'items'}</span>
//         )}
//       </div>

//       {error ? (
//         <div className="cart-error">{error}</div>
//       ) : !cart || cart.items.length === 0 ? (
//         renderEmptyCart()
//       ) : (
//         <>
//           <div className="cart-items">
//             {cart.items.map((item) => {
//               const productId = item.product || item.product_id;
//               const variantId = item.variant_id;

//               // Get variant image first if available, else fallback to product image
//               const imageUrl = variantId && productImages[`variant_${variantId}`]
//                 ? productImages[`variant_${variantId}`]
//                 : productImages[`product_${productId}`];

//               return (
//                 <div className="cart-item" key={item.id}>
//                   <div className="cart-item-image">
//                     {imageUrl ? (
//                       <img
//                         src={imageUrl}
//                         alt={`${item.product_name}`}
//                       />
//                     ) : (
//                       <div className="no-image">
//                         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
//                           <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
//                           <circle cx="8.5" cy="8.5" r="1.5"></circle>
//                           <polyline points="21 15 16 10 5 21"></polyline>
//                         </svg>
//                       </div>
//                     )}
//                   </div>

//                   <div className="cart-item-details">
//                     <h3 className="item-name">{item.product_name}</h3>

//                     {(item.variant_option1 || item.variant_option2) && (
//                       <div className="item-variants">
//                         {item.variant_option1 && (
//                           <span className="variant-tag">{item.variant_option1}</span>
//                         )}
//                         {item.variant_option2 && (
//                           <span className="variant-tag">{item.variant_option2}</span>
//                         )}
//                       </div>
//                     )}

//                     <div className="item-price-qty">
//                       <span className="item-price">${item.product_price}</span>
//                       <span className="item-quantity">Qty: {item.quantity}</span>
//                     </div>

//                     <div className="item-total">
//                       <span>Total: </span>
//                       <span className="total-price">${item.total_price}</span>
//                     </div>

//                     <button 
//                       className="remove-item-button"
//                       onClick={() => handleRemoveFromCart(productId, item.variant_id)}
//                     >
//                       Remove
//                     </button>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           <div className="cart-summary">
//             <div className="cart-totals">
//               <div className="subtotal">
//                 <span>Subtotal</span>
//                 <span>${cart.items.reduce((sum, item) => sum + parseFloat(item.total_price), 0).toFixed(2)}</span>
//               </div>
//               <div className="shipping">
//                 <span>Shipping</span>
//                 <span>Calculated at checkout</span>
//               </div>
//               <div className="total">
//                 <span>Total</span>
//                 <span>${cart.items.reduce((sum, item) => sum + parseFloat(item.total_price), 0).toFixed(2)}</span>
//               </div>
//             </div>

//             <div className="cart-actions">
//               <Link to="/shop" className="continue-shopping">
//                 Continue Shopping
//               </Link>
//               <Link to="/checkout" className="checkout-button">
//                 Proceed to Checkout
//               </Link>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// }

// export default Cart;


import { fetchProductById } from '../services/api';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Cart.css';
import { Link } from 'react-router-dom';
import { API_URL } from '../services/api';

function Cart() {
  const [cart, setCart] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [productImages, setProductImages] = useState({});
  const [notification, setNotification] = useState({
    show: false,
    type: '',
    message: ''
  });

  const fetchCart = async () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      setNotification({
        show: true,
        type: 'error',
        message: 'You must be logged in to view the cart'
      });
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
      return;
    }

    try {
      const response = await axios.get(`${API_URL}api/cart/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setCart(response.data);
      const images = {};

      for (const item of response.data.items) {
        const variantId = item.variant_id;
        const productId = item.product;

        // Fetch the product details
        const productData = await fetchProductById(productId);

        // Get the first image from the product's images array
        const productFirstImage = productData.images && productData.images.length > 0
          ? productData.images[0].image
          : null;

        // Store product's first image
        images[`product_${productId}`] = productFirstImage;

        // If there's a variant, also get its first image
        if (variantId) {
          const variantData = productData.variants.find(v => v.id === variantId);
          // Get the first image from the variant's images array
          const variantFirstImage = variantData && variantData.images && variantData.images.length > 0
            ? variantData.images[0].image
            : null;

          // Store variant's first image, falling back to product's first image if not available
          images[`variant_${variantId}`] = variantFirstImage || productFirstImage;
        }
      }


      setProductImages(images);
      setLoading(false);
    } catch (err) {
     // console.error('Error fetching cart:', err);

      // Check if the error is a 404 with message "Cart is empty"
      if (err.response && err.response.status === 404 &&
        err.response.data?.message === "Cart is empty") {
        // Set cart to empty object with empty items array
        setCart({ items: [] });
      // } else {
      //   setError('Unable to load your cart. Please try again.');
      //   if (err.response && err.response.status === 401 &&
      //     setTimeout(() => {
      //       window.location.href = '/login';
      //     }, 2000);
        
      //   }
      // }

    } else {
      setError('Unable to load your cart. Please try again.');
      
      if (err.response && err.response.status === 401) {
        setTimeout(() => {
          window.location.href = '/login';
        }, 2000);
      }
    }

      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);

  // Auto-hide notification after 3 seconds
  useEffect(() => {
    let timer;
    if (notification.show) {
      timer = setTimeout(() => {
        setNotification(prev => ({ ...prev, show: false }));
      }, 3000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [notification.show]);

  const handleRemoveFromCart = async (productId, variantId = null) => {
    try {
      const accessToken = localStorage.getItem('access_token');

      let url = `${API_URL}api/remove-from-cart/${productId}/`;

      setLoading(true);

      await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        data: {
          variant_id: variantId,
        },
      });

      setNotification({
        show: true,
        type: 'success',
        message: 'Item removed from cart'
      });

      fetchCart();
    } catch (error) {
      console.error("Error removing item from cart:", error);
      setNotification({
        show: true,
        type: 'error',
        message: error.response?.data?.error || "Failed to remove item."
      });
      setLoading(false);
    }
  };

  const closeNotification = () => {
    setNotification(prev => ({ ...prev, show: false }));
  };

  // const renderEmptyCart = () => (
  //   <div className="empty-cart">
  //     <div className="empty-cart-icon">
  //       <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
  //         <circle cx="9" cy="21" r="1"></circle>
  //         <circle cx="20" cy="21" r="1"></circle>
  //         <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
  //       </svg>
  //     </div>
  //     <h2>Your cart is empty</h2>
  //     <p>Looks like you haven't added any products to your cart yet.</p>
  //     <Link to="/shop" className="shop-now-button">
  //       Shop Now
  //     </Link>
  //   </div>
  // );

  const renderEmptyCart = () => (
    <div className="empty-cart">
      <div className="empty-cart-icon">
        <span className="cart-emoji">🛒</span>
      </div>
      <h2>Your cart is empty</h2>
      <p>Please add items to your cart!</p>
      <Link to="/shop" className="shop-now-button">
        Shop Now
      </Link>
    </div>
  );

  return (
    <div className="cart-page">
      {/* Notification Component - Moved above loading overlay so it appears on top */}


      {/* Loading Spinner */}
      {loading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}

      {notification.show && (
        <div className={`notification-popup ${notification.type}`}>
          <div className="notification-content">
            <span className="notification-message">{notification.message}</span>
            <button
              className="notification-close-button"
              onClick={closeNotification}
            >
              ×
            </button>
          </div>
        </div>
      )}

      <div className="cart-header">
        <h1>Your Cart</h1>
        {cart && cart.items.length > 0 && (
          <span className="item-count">{cart.items.length} {cart.items.length === 1 ? 'item' : 'items'}</span>
        )}
      </div>

      {error ? (
        <div className="cart-error">{error}</div>
      ) : !cart || cart.items.length === 0 ? (
        renderEmptyCart()
      ) : (
        <>
          <div className="cart-items">
            {cart.items.map((item) => {
              const productId = item.product || item.product_id;
              const variantId = item.variant_id;

              // Get variant image first if available, else fallback to product image
              const imageUrl = variantId && productImages[`variant_${variantId}`]
                ? productImages[`variant_${variantId}`]
                : productImages[`product_${productId}`];

              return (
                <div className="cart-item" key={item.id}>
                  <div className="cart-item-image">
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt={`${item.product_name}`}
                      />
                    ) : (
                      <div className="no-image">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                          <circle cx="8.5" cy="8.5" r="1.5"></circle>
                          <polyline points="21 15 16 10 5 21"></polyline>
                        </svg>
                      </div>
                    )}
                  </div>

                  <div className="cart-item-details">
                    <h3 className="item-name">{item.product_name}</h3>

                    {(item.variant_option1 || item.variant_option2) && (
                      <div className="item-variants">
                        {item.variant_option1 && (
                          <span className="variant-tag">{item.variant_option1}</span>
                        )}
                        {item.variant_option2 && (
                          <span className="variant-tag">{item.variant_option2}</span>
                        )}
                      </div>
                    )}

                    <div className="item-price-qty">
                      <span className="item-price">${item.product_price}</span>
                      <span className="item-quantity">Qty: {item.quantity}</span>
                    </div>

                    <div className="item-total">
                      <span>Total: </span>
                      <span className="total-price">${item.total_price}</span>
                    </div>

                    <button
                      className="remove-item-button"
                      onClick={() => handleRemoveFromCart(productId, item.variant_id)}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="cart-summary">
            <div className="cart-totals">
              <div className="subtotal">
                <span>Subtotal</span>
                <span>${cart.items.reduce((sum, item) => sum + parseFloat(item.total_price), 0).toFixed(2)}</span>
              </div>
              <div className="shipping">
                <span>Shipping</span>
                <span>Calculated at checkout</span>
              </div>
              <div className="total">
                <span>Total</span>
                <span>${cart.items.reduce((sum, item) => sum + parseFloat(item.total_price), 0).toFixed(2)}</span>
              </div>
            </div>

            <div className="cart-actions">
              <Link to="/shop" className="continue-shopping">
                Continue Shopping
              </Link>
              <Link to="/checkout" className="checkout-button">
                Proceed to Checkout
              </Link>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default Cart;